import Doctor from "../../../assets/images/patience/doctor.png"
import Diagnostics from "../../../assets/images/patience/diagnostics.webp"
import Pharmacy from "../../../assets/images/patience/pharmacy.png"
import Hospitals from "../../../assets/images/patience/hospitals.png"
 
 const servicesData = [
        {
            id: 1,
            title: "Doctor",
            description: "Book OPD consultation with verified doctors",
            buttonText: "View Doctor",
            image: Doctor,
        },
        {
            id: 2,
            title: "Lab Diagnostics",
            description: "Blood tests & diagnostics near you",
            buttonText: "View Lab",
            image: Diagnostics,
        },
        {
            id: 3,
            title: "Pharmacy",
            description: "Order medicines from trusted pharmacies",
            buttonText: "View Pharmacy",
            image: Pharmacy,
        },
        {
            id: 4,
            title: "Hospitals",
            description: "Find hospitals & health centers nearby",
            buttonText: "View Hospitals",
            image: Hospitals,
        },
    ];


export default servicesData;